package org.multiplatform.kotfolio.pages.listing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("hydraulic_press_machine")
@Composable
fun HydraulicPressMachine() {
    BlogLayout(
        PageProperties(
            "Hydraulic Press",
            ""
        ),
        BlogProperties("Machine", "Hydraulic Press")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Title",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )
        }
    }
}

//https://zxhydraulicpress.com/blog/hydraulic-presses-design/